export { default } from "./ClickHeading";
